import React, { useState } from "react";
import { FaWhatsapp, FaPhoneAlt } from "react-icons/fa";
import "./ChatBot.css";

const WHATSAPP_NUMBER = "919289870037";
const PHONE_NUMBER = "918010521052";

const WhatsAppFloat = () => {
  const [open, setOpen] = useState(false);

  return (
    <div className={`whatsapp-wrapper ${open ? "open" : ""}`}>
      <div className="whatsapp-options">
        <a
          className="whatsapp-option"
          href={`tel:+${PHONE_NUMBER}`}
          aria-label="Call 8010521052"
        >
          <FaPhoneAlt />
          <span>Call Us</span>
        </a>

        <a
          className="whatsapp-option"
          href={`https://wa.me/${WHATSAPP_NUMBER}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaWhatsapp />
          <span>WhatsApp</span>
        </a>
      </div>

      <button
        type="button"
        className="whatsapp-float"
        aria-label={open ? "Close contact options" : "Open contact options"}
        aria-expanded={open}
        onClick={() => setOpen((current) => !current)}
      >
        <FaWhatsapp />
      </button>
    </div>
  );
};

export default WhatsAppFloat;